import { Button } from "react-bootstrap";
import classRoomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import "./Classroom.css";
import ClassroomTable from "./ClassroomTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import RoleGuard from "../../../auth/RoleGuard";
/**
 * @param {Object} props
 * @param {string} props.type - Type of classroom (teacher-admin or school-admin)
 */
const Classroom = ({ type }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const teacherId = searchParams.get("teacherId") || "";

  return (
    <div className="classroom-cnt">
      <div className="classroom-container">
        <img src={classRoomImg} className="img" alt="Classroom" />
        <h2 className="text">Manage Classroom(s)</h2>
      </div>

      <div className="btn-container">
        <RoleGuard permission="dashboard_create_classroom">
          <Button
            className="primary-btn"
            onClick={() => {
              if (type === "school-admin") {
                navigate("/school-admin/classroom/create");
              } else {
                navigate("/teacher/classroom/create");
              }
            }}
          >
            Create Classroom
          </Button>
        </RoleGuard>
      </div>
      <div>
        <ClassroomTable teacherId={teacherId} type={type} />
      </div>
    </div>
  );
};

export default Classroom;
